module.exports = __webpack_public_path__ + "static/media/tyen.f7a53b57.jpg";